// src/components/YouTubeThumbnail.jsx
import React, { useRef } from "react";
import { toPng } from "html-to-image";

const YouTubeThumbnail = ({ title, thumbnailUrl, author }) => {
  const ref = useRef();

const downloadImage = async () => {
  if (!ref.current) return;

  try {
    const dataUrl = await toPng(ref.current);
    const link = document.createElement("a");
    link.download = `${title}.png`;
    link.href = dataUrl;
    link.click();
  } catch (error) {
    console.error("Fehler beim PNG-Export:", error);
    alert("Bild konnte nicht exportiert werden.");
  }
};

  return (
    <div className="w-80 h-48 relative rounded-lg shadow-lg overflow-hidden border border-gray-300" ref={ref}>
      {thumbnailUrl ? (
        <img
          src={thumbnailUrl}
          alt="Video Thumbnail"
          className="w-full h-full object-cover"
        />
      ) : (
        <div className="w-full h-full bg-gray-800 flex items-center justify-center text-white text-xl font-bold">
          Kein Bild
        </div>
      )}

      {/* Overlay mit Text */}
      <div className="absolute bottom-0 left-0 w-full bg-gradient-to-t from-black/80 to-transparent p-3">
        <h3 className="text-white text-lg font-semibold truncate">{title}</h3>
        {author && <p className="text-sm text-white/70">{author}</p>}
      </div>

      {/* YouTube Icon */}
      <div className="absolute top-2 left-2 bg-white p-1 rounded-full shadow-md">
        <svg className="w-6 h-6 text-red-600" fill="currentColor" viewBox="0 0 24 24">
          <path d="M10 15l5-3-5-3v6z" />
          <path d="M19.5 3h-15A1.5 1.5 0 003 4.5v15A1.5 1.5 0 004.5 21h15a1.5 1.5 0 001.5-1.5v-15A1.5 1.5 0 0019.5 3zM21 19.5a1.5 1.5 0 01-1.5 1.5h-15A1.5 1.5 0 013 19.5v-15A1.5 1.5 0 014.5 3h15A1.5 1.5 0 0121 4.5v15z" />
        </svg>
      </div>

      {/* PNG Export Button */}
      <button
        onClick={downloadImage}
        className="absolute top-2 right-2 bg-white px-2 py-1 text-sm rounded shadow hover:bg-gray-100"
      >
        PNG exportieren
      </button>
    </div>
  );
};

export default YouTubeThumbnail;
